import React from 'react';
import moment from 'moment';

const CalendarWeekNavigator = ({
  minYear, maxYear, year, month, day, onChange,
}) => {
  const previousDisabled = (day >= 1 && day <= 7) && month === 0 && year <= minYear;
  const nextDisabled = day >= 22 && month === 11 && year >= maxYear;
  const handleChangeDate = (type, nbDays) => {
    const newDate = moment({ year, month, day });
    if (type === 'previous') {
      newDate.subtract(nbDays, 'days');
    } else {
      newDate.add(nbDays, 'days');
    }
    onChange({ year: newDate.year(), month: newDate.month(), day: newDate.date() });
  };
  return (
    <div>
      <button type="button" className="btn btn-xs btn-info previous pull-left" onClick={ handleChangeDate.bind(null, 'previous', 7) } disabled={ previousDisabled }>
        <i className="fa fa-chevron-left"></i>
      </button>
      <button type="button" className="btn btn-xs btn-info next pull-right" onClick={ handleChangeDate.bind(null, 'next', 7) } disabled={ nextDisabled }>
        <i className="fa fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default CalendarWeekNavigator;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/CalendarWeekNavigator.jsx